// tslint:disable

import * as React from 'react';
import {InputField} from '../../components/fields/input.field';
import {FormLib} from '../../components/libs/form.lib';
import {ResourceLoader} from '../../components/libs/resource-loader';
import {DefaultSave} from '../../components/libs/updaters/default-save';
import {Validators} from '../../components/libs/Validators';
import {LoaderComponent} from '../../components/structurals/loader.component';
import {ToggleBoxComponent} from '../../components/structurals/toggle-box.component';

export class DefaultEventGuestType extends React.Component<any, any> {
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateForm(form);
        await this.executor.exec();
    }

    render() {
        return (
            <ResourceLoader entity="guest-type" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div>
                <div id="page-title">
                    <h2>
                        {this.props.IS_CREATE ? 'Create new guest type' : 'Edit guest type'}
                    </h2>
                    <p>Lorem</p>
                </div>
                <LoaderComponent isLoading$={this.executor.loading$}/>
                <ToggleBoxComponent title="Guest type details" color="green" alwaysOpen={true}>
                    <div className="row">
                        <div className="col-xs-12">
                            <InputField
                                field={form.fields.title}
                                validators={[
                                    Validators.required('Required')
                                ]}/>

                            <button className="btn btn-success pull-left" onClick={() => this.saveForm(form)}>Save
                            </button>
                        </div>
                    </div>
                </ToggleBoxComponent>
            </div>}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.event-guest-type.tsx